export { ShowOnMobile, ShowOnDesktop } from './styles';
